import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";
import { selectDecoded } from "src/redux/reducers/authSlice";
import { hasAnyRole } from "src/utils/roleUtils";

interface Props {
  allowedRoles: string[];
}

const RoleRoute = ({ allowedRoles }: Props) => {
  const decoded = useSelector(selectDecoded);

  return hasAnyRole(decoded, allowedRoles) ? (
    <Outlet/>
  ) : (
    <Navigate to="/notFound" />
  );
};

export default RoleRoute;
